<template>
  <div v-if="create || badge._id">
    <div class="container text-left">
      <div class="row">
        <div class="col-lg-12">
          <BreadcrumbsHelper class="sn-bread" :breadcrumbs="this.Breadcrumbs" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 mt-2">
          <b-card>
            <div class="row">
              <div class="col-lg-6">
                <h1 v-if="create" class="title">Untitled Badge</h1>
                <h1 v-else class="title">{{ badge.name }}</h1>
              </div>
              <div class="col-lg-6 text-right">
                <button v-if="!create" @click="deleteBadge()" class="btn btn-white delete">Delete</button>
              </div>
            </div>
            <b-form @submit.prevent="onSubmit">
              <div class="card-info row">
                <div class="col-lg-12">
                  <b-form-group label="Badge Title (Required)" label-for="badgeName">
                    <b-form-input id="badgeName" v-model="badge.name" placeholder="Badge Title" type="text" :state="submitted && $v.badge.name.$error ? false : null" />
                    <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.badge.name.required">
                      <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a title
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label="Internal Url (Required)" label-for="internalUrl">
                    <b-form-input id="internalUrl" v-model="badge.page" placeholder="experience-alabama/civil-rights" />
                    <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.badge.page.required">
                      <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter an internal url
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label="Badge (Required)" label-for="logo">
                    <img
                      v-if="!create && badge.image !== ''"
                      class="logo"
                      :src="`https://alabama-travel.s3.amazonaws.com/partners-uploads/badge/image/${badge._id}/${badge.image}`"
                    />
                    <badgeUpload v-on:updateFiles="updateLogos" @isNowValid="isValid($event)" ref="logoUpload" />
                  </b-form-group>
                  <b-form-invalid-feedback class="d-block red" v-if="submitted && logoStatus === false">
                    <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please upload a logo
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback class="final-alert d-block" v-if="submitted && (this.$v.$invalid || logoStatus === false)">
                    <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />
                    <span aria-live="polite" class="validation-message">Double check the required fields. We don't have everything we need to save the record.</span>
                  </b-form-invalid-feedback>
                  <div class="save-button">
                    <b-button type="submit" @click="saveBtn($event)" :disabled="submitted && $v.$invalid">Save</b-button>
                  </div>
                </div>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
import badgeUpload from '../../components/BadgeUpload.vue';
import stateList from '../../assets/state-list.json';
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';

export default {
  components: {
    badgeUpload,
    BreadcrumbsHelper,
  },
  data() {
    return {
      badge: {
        name: '',
        page: '',
        image: '',
      },
      Breadcrumbs: [
        {
          text: 'Settings',
          active: true,
        },
        {
          text: 'Badges',
          href: '/badges',
        },
        {
          text: '',
          active: true,
        },
      ],
      badgeEvents: [],
      logoStatus: false,
      logoImageName: null,
      submitted: false,
      stateOptions: stateList,
      loaded: false,
      disabled: false,
    };
  },
  validations: {
    badge: {
      name: {
        required,
      },
      page: {
        required,
      },
    },
  },
  props: {
    badgeId: String,
    create: Boolean,
  },
  async created() {
    if (!this.create) {
      const Badge = await axios.get(`${process.env.VUE_APP_API_ROOT}/misc/badges/${this.badgeId}`);
      await Promise.all([this.getLocations(), this.getEvents()]);
      // if statement to stop deletion if badge is connected to a location or event so that it doesn't break the location or event --JP
      if (
        (Badge.data.location_ids && Badge.data.location_ids.length > 0)
        || (this.badgeEvents && this.badgeEvents.length > 0)
        || (this.badgeLocations && this.badgeLocations.length > 0)
      ) {
        this.disabled = true;
      }
      let badge = this.$store.getters['misc/getBadgeById'](this.badgeId);
      this.loaded = true;
      if (this.loaded) {
        this.Breadcrumbs[2].text = `${badge.name} Edit`;
      }
      if (!badge) {
        await this.$store.dispatch('misc/getBadges', this.badgeId);
        badge = this.$store.getters['misc/getBadgeById'](this.badgeId);
      }
      this.badge = { ...this.badge, ...badge };
    } else if (this.create) {
      this.Breadcrumbs[2].text = 'New Badge';
    }
  },
  methods: {
    async onSubmit() {
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }
      if (this.badge.image) {
        this.logoStatus = true;
      }
      const url = this.create ? `${process.env.VUE_APP_API_ROOT}/misc/badges` : `${process.env.VUE_APP_API_ROOT}/misc/badges/${this.badgeId}`;

      if (this.logoStatus === false) {
        const message = 'Please upload a logo';
        this.$bvToast.toast(message, {
          title: 'Error',
          autoHideDelay: 8000,
          appendToast: true,
        });
        this.isLoading = false;
        return;
      }
      try {
        const updateBadge = await axios.post(url, this.badge);
        if (updateBadge.data.errmsg) {
          this.$bvToast.toast(JSON.stringify(updateBadge.data.errmsg), {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: false,
          });
        } else {
          await this.$refs.logoUpload.uploadFiles(updateBadge.data._id);
          if (this.logoImageName && this.logoImageName[0] && this.logoImageName[0].imageName) {
            updateBadge.data.image = this.logoImageName[0].imageName;

            const updateUrl = this.create ? `${url}/${updateBadge.data._id}` : url;

            const updateLogoName = await axios.post(updateUrl, updateBadge.data);
            if (updateLogoName.data.errmsg) {
              this.$bvToast.toast(JSON.stringify(updateLogoName.data.errmsg), {
                title: 'Error',
                autoHideDelay: 5000,
                appendToast: false,
              });
            } else {
              const self = this;
              this.$store.commit('misc/updateBadge', this.badge);
              this.$router.push('/badges', () => {
                setTimeout(() => {
                  self.$bvToast.toast('Badge Updated', { title: 'Success', autoHideDelay: 5000, appendToast: true });
                }, 500);
              });
            }
          } else if (updateBadge.data.image) {
            const self = this;
            this.$store.commit('misc/updateBadge', this.badge);
            this.$router.push('/badges', () => {
              setTimeout(() => {
                self.$bvToast.toast('Badge Updated', { title: 'Success', autoHideDelay: 5000, appendToast: true });
              }, 500);
            });
          } else {
            console.log('Error Updating Image Name'); // DO NOT DELETE
          }
        }
      } catch (err) {
        this.$bvToast.toast('Something went wrong.', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: false,
        });
      }
    },
    isValid(logoStatus) {
      this.logoStatus = logoStatus;
    },
    saveBtn(event) {
      if (!this.$v.$invalid) {
        event.target.innerText = 'Saving...';
      }
    },
    async deleteBadge() {
      // if statement to stop deletion if badge is connected to a location or event so that it doesn't break the location or event --JP
      if (this.disabled === true) {
        const self = this;
        self.$bvToast.toast('This badge cannot be deleted. It is currently associated with a location or event', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      } else {
        const response = await axios.delete(`${process.env.VUE_APP_API_ROOT}/misc/badges/${this.badgeId}`);
        this.badge = response.data;
        if (response.status === 200) {
          const self = this;
          this.$router.push('/badges', () => {
            setTimeout(() => {
              self.$bvToast.toast('Badge Deleted', { title: 'Success', autoHideDelay: 5000, appendToast: true });
            }, 500);
          });
        } else {
          this.$bvToast.toast(JSON.parse(response.data).message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      }
    },
    updateLogos(logoFile) {
      this.logoImageName = logoFile;
    },
    async getEvents() {
      // to gather events with badges for badge deletion safety net -- JP
      const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/misc/getEventsForBadge/${this.badgeId}`);
      this.badgeEvents = response.data;
    },
    async getLocations() {
      // to gather locations with badges for badge deletion safety net -- JP
      const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/misc/getLocationsForBadge/${this.badgeId}`);
      this.badgeLocations = response.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  border: none;
}
.card-body h1 {
  margin: 0px !important;
  line-height: 4rem;
}
div.image-desc {
  width: 60%;
  font-size: 14px;
}
.final-alert {
  padding-top: 10px;
}
.logo {
  height: 200px;
  margin: 30px 0px 50px;
  width: 200px;
}
.validation-message {
  position: absolute;
}
</style>
